import { render, staticRenderFns } from "./detalle-legajo.vue?vue&type=template&id=4ba3c2cb&scoped=true&"
import script from "./detalle-legajo.component.ts?vue&type=script&lang=ts&"
export * from "./detalle-legajo.component.ts?vue&type=script&lang=ts&"
import style0 from "./detalle-legajo.vue?vue&type=style&index=0&id=4ba3c2cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba3c2cb",
  null
  
)

export default component.exports